import type { SVGComponentProps } from 'BreetHelpers';

export const ScannerAddressIcon = ({ ...rest }: SVGComponentProps) => (
	<svg
		width='30'
		height='30'
		viewBox='0 0 30 30'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<rect
			width='30'
			height='30'
			rx='15'
			fill='#F7F8F8'
		/>
		<path
			opacity='0.4'
			d='M9.61567 13.8346C9.36484 13.8346 9.1665 13.6363 9.1665 13.3855V12.038C9.1665 10.4571 10.4557 9.16797 12.0365 9.16797H13.384C13.6348 9.16797 13.8332 9.3663 13.8332 9.61714C13.8332 9.86797 13.6348 10.0663 13.384 10.0663H12.0365C10.9457 10.0663 10.0648 10.953 10.0648 12.038V13.3855C10.0648 13.6363 9.86067 13.8346 9.61567 13.8346Z'
			fill='#8193A2'
		/>
		<path
			opacity='0.4'
			d='M20.384 13.8346C20.139 13.8346 19.9348 13.6363 19.9348 13.3855V12.038C19.9348 10.9471 19.0482 10.0663 17.9632 10.0663H16.6157C16.3648 10.0663 16.1665 9.86214 16.1665 9.61714C16.1665 9.37214 16.3648 9.16797 16.6157 9.16797H17.9632C19.544 9.16797 20.8332 10.4571 20.8332 12.038V13.3855C20.8332 13.6363 20.6348 13.8346 20.384 13.8346Z'
			fill='#8193A2'
		/>
		<path
			d='M17.9631 20.8351H17.1523C16.9073 20.8351 16.7031 20.6368 16.7031 20.3859C16.7031 20.1409 16.9015 19.9368 17.1523 19.9368H17.9631C19.054 19.9368 19.9348 19.0501 19.9348 17.9651V17.1601C19.9348 16.9151 20.1331 16.7109 20.384 16.7109C20.629 16.7109 20.8331 16.9093 20.8331 17.1601V17.9651C20.8331 19.5459 19.544 20.8351 17.9631 20.8351Z'
			fill='#8193A2'
		/>
		<path
			d='M13.384 20.8346H12.0365C10.4557 20.8346 9.1665 19.5455 9.1665 17.9646V16.6171C9.1665 16.3663 9.36484 16.168 9.61567 16.168C9.8665 16.168 10.0648 16.3663 10.0648 16.6171V17.9646C10.0648 19.0555 10.9515 19.9363 12.0365 19.9363H13.384C13.629 19.9363 13.8332 20.1346 13.8332 20.3855C13.8332 20.6363 13.6348 20.8346 13.384 20.8346Z'
			fill='#8193A2'
		/>
		<path
			d='M18.7685 14.5508H17.9752H12.0252H11.2319C10.981 14.5508 10.7827 14.7549 10.7827 14.9999C10.7827 15.2449 10.981 15.4491 11.2319 15.4491H12.0252H17.9752H18.7685C19.0194 15.4491 19.2177 15.2449 19.2177 14.9999C19.2177 14.7549 19.0194 14.5508 18.7685 14.5508Z'
			fill='#8193A2'
		/>
		<path
			d='M12.0249 16.1303V16.3228C12.0249 17.2911 12.8066 18.0728 13.7749 18.0728H16.2249C17.1932 18.0728 17.9749 17.2911 17.9749 16.3228V16.1303C17.9749 16.0603 17.9224 16.0078 17.8524 16.0078H12.1474C12.0774 16.0078 12.0249 16.0603 12.0249 16.1303Z'
			fill='#022745'
		/>
		<path
			opacity='0.4'
			d='M12.0249 13.8683V13.6758C12.0249 12.7074 12.8066 11.9258 13.7749 11.9258H16.2249C17.1932 11.9258 17.9749 12.7074 17.9749 13.6758V13.8683C17.9749 13.9383 17.9224 13.9908 17.8524 13.9908H12.1474C12.0774 13.9908 12.0249 13.9383 12.0249 13.8683Z'
			fill='#022745'
		/>
	</svg>
);
